require('./angular');
module.exports = angular;



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular/index.js
 ** module id = 4
 ** module chunks = 0
 **/